// @ts-strict-ignore
// import { useUserAccessibleChannels } from "@dashboard/auth/hooks/useUserAccessibleChannels";
// import { useContextualLink } from "@dashboard/components/AppLayout/ContextualLinks/useContextualLink";
import { LimitsInfo } from "@dashboard/components/AppLayout/LimitsInfo";
// import { ListFilters } from "@dashboard/components/AppLayout/ListFilters";
import { TopNav } from "@dashboard/components/AppLayout/TopNav";
import { DashboardCard } from "@dashboard/components/Card";
// import { useConditionalFilterContext } from "@dashboard/components/ConditionalFilter";
// import { createOrderQueryVariables } from "@dashboard/components/ConditionalFilter/queryVariables";
// import { useDevModeContext } from "@dashboard/components/DevModePanel/hooks";
import { FilterPresetsSelect } from "@dashboard/components/FilterPresetsSelect";
import { ListPageLayout } from "@dashboard/components/Layouts";
// import { extensionMountPoints } from "@dashboard/extensions/extensionMountPoints";
// import {
//   getExtensionItemsForOverviewCreate,
//   getExtensionsItemsForOrderOverviewActions,
// } from "@dashboard/extensions/getExtensionsItems";
// import { useExtensions } from "@dashboard/extensions/hooks/useExtensions";
import { OrderListQuery, RefreshLimitsQuery } from "@dashboard/graphql";
import { sectionNames } from "@dashboard/intl";
import { orderMessages } from "@dashboard/orders/messages";
// import { DevModeQuery } from "@dashboard/orders/queries";
import { OrderListUrlQueryParams, OrderListUrlSortField, orderUrl } from "@dashboard/orders/urls";
import {
  PageListProps,
  RelayToFlat,
  SearchPageProps,
  SortPage,
  TabPageProps,
} from "@dashboard/types";
import { hasLimits, isLimitReached } from "@dashboard/utils/limits";
import { Box, ChevronRightIcon } from "@saleor/macaw-ui-next";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import OrderLimitReached from "../OrderLimitReached";
import { OrderListDatagrid } from "../OrderListDatagrid";
import { Button } from "@saleor/macaw-ui";
import { FormattedMessage } from "react-intl";

export interface OrderListPageProps
  extends PageListProps,
    SearchPageProps,
    Omit<TabPageProps, "onTabDelete">,
    SortPage<OrderListUrlSortField> {
  limits: RefreshLimitsQuery["shop"]["limits"];
  orders: RelayToFlat<OrderListQuery["orders"]>;
  hasPresetsChanged: boolean;
  onSettingsOpen: () => void;
  onAdd: () => void;
  params: OrderListUrlQueryParams;
  onTabUpdate: (tabName: string) => void;
  onTabDelete: (tabIndex: number) => void;
  selectedOrderIds?: string[]; // Add this
  onSendToEvolve?: () => void; // Add this
  isVendor?: boolean; // Add this
  sendingToEvolve?: boolean; // Add this
  onRowSelectionChange?: (rows: number[], clearSelection: () => void) => void; // Add this
  activeOrderTab: "all" | "specific"; // new
  setActiveOrderTab: React.Dispatch<React.SetStateAction<"all" | "specific">>; // new
}

const OrderListPage = ({
  initialSearch,
  limits,
  onAdd,
  onSearchChange,
  onSettingsOpen,
  params,
  onTabChange,
  onTabDelete,
  onTabSave,
  onTabUpdate,
  tabs,
  onAll,
  currentTab,
  hasPresetsChanged,
  selectedOrderIds = [], // Add this
  onSendToEvolve, // Add this
  isVendor = false, // Add this
  sendingToEvolve = false, // Add this
  onRowSelectionChange, // Add this
  activeOrderTab,
  setActiveOrderTab,
  ...listProps
}: OrderListPageProps) => {
  const intl = useIntl();
  // const subtitle = useContextualLink("order_list");
  // const userAccessibleChannels = useUserAccessibleChannels();
  // const hasAccessibleChannels = userAccessibleChannels.length > 0;
  const limitsReached = isLimitReached(limits, "orders");
  const [isFilterPresetOpen, setFilterPresetOpen] = useState(false);
  // const { ORDER_OVERVIEW_CREATE, ORDER_OVERVIEW_MORE_ACTIONS } = useExtensions(
  //   extensionMountPoints.ORDER_LIST,
  // );
  // const extensionMenuItems = getExtensionsItemsForOrderOverviewActions(ORDER_OVERVIEW_MORE_ACTIONS);
  // const extensionCreateButtonItems = getExtensionItemsForOverviewCreate(ORDER_OVERVIEW_CREATE);
  // const context = useDevModeContext();
  // const { valueProvider } = useConditionalFilterContext();

  // const openPlaygroundURL = () => {
  //   // context.setDevModeContent(DevModeQuery);

  //   // const variables = JSON.stringify(
  //   //   {
  //   //     filter: createOrderQueryVariables(valueProvider.value),
  //   //     // TODO add sorting: Issue #3409
  //   //     // strange error when uncommenting this line
  //   //     // sortBy: getSortQueryVariables(params)
  //   //   },
  //   //   null,
  //   //   2,
  //   // );

  //   // context.setVariables(variables);
  //   // context.setDevModeVisibility(true);
  // };

  return (
    <ListPageLayout>
      <TopNav
        title={intl.formatMessage(sectionNames.orders)}
        // subtitle={subtitle}
        withoutBorder
        isAlignToRight={false}
      >
        <Box __flex={1} display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex">
            <Box marginX={3} display="flex" alignItems="center">
              <ChevronRightIcon />
            </Box>

            <FilterPresetsSelect
              presetsChanged={hasPresetsChanged}
              onSelect={onTabChange}
              onRemove={onTabDelete}
              onUpdate={onTabUpdate}
              savedPresets={tabs}
              activePreset={currentTab}
              onSelectAll={onAll}
              onSave={onTabSave}
              isOpen={isFilterPresetOpen}
              onOpenChange={setFilterPresetOpen}
              selectAllLabel={intl.formatMessage(orderMessages.filterPresetsAll)}
            />
          </Box>

          <Box display="flex" alignItems="center" gap={2}>
            {/* Show "Send to Evolve" button for vendors when orders are selected */}
            {isVendor && selectedOrderIds.length > 0 && onSendToEvolve && (
              <>
                <Button
                  onClick={onSendToEvolve}
                  disabled={sendingToEvolve}
                  data-test-id="send-to-evolve-button"
                  variant="secondary"
                >
                  <FormattedMessage
                    id="sendToEvolve"
                    defaultMessage={
                      sendingToEvolve
                        ? "Sending to Evolve..."
                        : `Send to Evolve (${selectedOrderIds.length})`
                    }
                    description="button"
                  />
                </Button>
              </>
            )}

            {isVendor ? (
              <>
                <Button
                  variant={activeOrderTab === "all" ? "primary" : "secondary"}
                  onClick={() => {
                    setActiveOrderTab("all");
                    listProps.onRowSelectionChange?.([], () => {});
                  }}
                >
                  My Orders
                </Button>
                <Button
                  variant={activeOrderTab === "specific" ? "primary" : "secondary"}
                  onClick={() => setActiveOrderTab("specific")}
                >
                  Evolve Orders
                </Button>
              </>
            ) : null}

            {/** Settings and Create order actions intentionally hidden on Orders page **/}

            {hasLimits(limits, "orders") && (
              <LimitsInfo
                text={intl.formatMessage(
                  {
                    id: "zyceue",
                    defaultMessage: "{count}/{max} orders",
                    description: "placed order counter",
                  },
                  {
                    count: limits.currentUsage.orders,
                    max: limits.allowedUsage.orders,
                  },
                )}
              />
            )}
          </Box>
        </Box>
      </TopNav>

      {limitsReached && <OrderLimitReached />}

      <DashboardCard>
        {/* <ListFilters
          type="expression-filter"
          initialSearch={initialSearch}
          onSearchChange={onSearchChange}
          searchPlaceholder={intl.formatMessage({
            id: "wTHjt3",
            defaultMessage: "Search Orders...",
          })}
        /> */}
        <OrderListDatagrid
          {...listProps}
          hasRowHover={!isFilterPresetOpen}
          rowAnchor={orderUrl}
          onRowSelectionChange={onRowSelectionChange}
        />
      </DashboardCard>
    </ListPageLayout>
  );
};

OrderListPage.displayName = "OrderListPage";
export default OrderListPage;
